<ion-header *ngIf="authServ.isLogged">
  <ion-toolbar>
    <ion-button
      class="ion-no-padding"
      (click)="close()"
      slot="start"
      color="dark"
      fill="clear"
    >
      <ion-icon name="chevron-back"></ion-icon>
    </ion-button>

    <ion-title>
      <ion-text color="dark" class="ion-text-center">
        <h1>{{ itemData.name | caption | translate }}</h1>
      </ion-text>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="form-content" *ngIf="authServ.isLogged; else noLogged">
  <ion-grid class="form">
    <ion-row
      *ngIf="
        today
          | isBetweenTimes
            : itemData.service_start_time
            : itemData.service_end_time
      "
    >
      <ion-col size="12">
        <div class="badge" color="primary">
          {{ itemData.response_for_service_out_side_hours | caption }}
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" offset="4">
        <img [src]="serviceData.image_url" />
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1>
            <b>{{ serviceData.title | caption | translate }}</b>
          </h1>
          <p>{{ serviceData.description | caption | translate }}</p>
        </ion-text>
      </ion-col>

      <ion-col
        size="12"
        *ngIf="serviceData.select_values | caption | translate"
      >
        <ion-item class="border select-item">
          <ion-icon
            slot="start"
            size="small"
            name="caret-down-outline"
            color="dark"
          ></ion-icon>
          <ion-select
            [(ngModel)]="type"
            placeholder="{{ 'Please Select Request Type' | translate }}"
          >
            <ion-select-option
              [value]="option"
              *ngFor="
                let option of (
                  serviceData.select_values
                  | caption
                  | translate
                ).split('|')
              "
              [innerHtml]="option"
            >
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>

      <ng-container *ngIf="sectionData.id === 113">
        <ion-col size="12">
          <ion-item class="qty">
            <ion-buttons>
              <ion-text class="label">
                {{ "Quantity" | caption | translate }}
              </ion-text>

              <ion-button (click)="quantity > 0 && (quantity = quantity - 1)">
                <ion-icon slot="icon-only" name="remove"></ion-icon>
              </ion-button>

              <ion-text color="primary">
                <b>{{ quantity }}</b>
              </ion-text>

              <ion-button (click)="quantity = quantity + 1">
                <ion-icon slot="icon-only" name="add"></ion-icon>
              </ion-button>
            </ion-buttons>
          </ion-item>
        </ion-col>
      </ng-container>

      <app-extra-forms></app-extra-forms>

      <ion-col size="12">
        <ion-item>
          <ion-textarea
            #noteInput
            rows="4"
            placeholder="{{ 'Notes' | translate }}"
          ></ion-textarea>
        </ion-item>
      </ion-col>

      <ion-col size="12" *ngIf="sectionData.id === 115">
        <input
          type="file"
          accept="image/*"
          class="ion-hide"
          #photoInput
          (change)="uploadPhoto(photoInput.files[0])"
        />

        <ion-button
          (click)="takePicture(photoInput)"
          class="add-photo"
          expand="block"
          color="light-medium"
        >
          <ion-icon slot="start" name="camera"></ion-icon>
          {{ "You Can Add Image For Detail" | translate }}
        </ion-button>
      </ion-col>

      <ion-col size="12" *ngIf="photo">
        <ion-img [src]="photo"></ion-img>

        <ion-button
          (click)="photo = null"
          expand="block"
          class="clear-button"
          fill="clear"
          color="primary"
        >
          {{ "Clear" | translate }}
        </ion-button>
      </ion-col>

      <ion-col size="12">
        <ion-button
          [disabled]="processing"
          (click)="send(noteInput.value)"
          class="send-button"
          expand="block"
          color="primary"
        >
          <ion-spinner name="lines" *ngIf="processing"></ion-spinner>
          {{ "Send" | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ng-template #noLogged>
  <!-- <ion-button (click)="close()" fill="clear" color="light" class="ion-no-padding login-back">
    <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
  </ion-button> -->
  <app-profile [isModal]="true"></app-profile>
</ng-template>
